import { render } from "./ReplyNice.vue?vue&type=template&id=7e9512a8&ts=true"
import script from "./ReplyNice.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyNice.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyNice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e9512a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e9512a8', __exports__)) {
    api.reload('7e9512a8', __exports__)
  }
  
  module.hot.accept("./ReplyNice.vue?vue&type=template&id=7e9512a8&ts=true", () => {
    api.rerender('7e9512a8', render)
  })

}


export default __exports__